import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './Nav.module.css';

const LINKS = [
  { label: 'Home',      path: '/'          },
  { label: 'Solutions', path: '/solutions' },
  { label: 'Impact',    path: '/impact'    },
  { label: 'About',     path: '/about'     },
  { label: 'Blog',      path: '/blog'      },
  { label: 'Contact',   path: '/contact'   },
];

export default function Nav() {
  const { pathname } = useLocation();
  const [scrolled,  setScrolled]  = useState(false);
  const [menuOpen,  setMenuOpen]  = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', fn, { passive: true });
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [pathname]);

  return (
    <header className={`${styles.header} ${scrolled ? styles.scrolled : ''}`}>
      <div className={styles.inner}>
        {/* Logo */}
        <Link to="/" className={styles.logo}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M21 3C21 3 12 3 7 8C2 13 3 21 3 21C3 21 11 22 16 17C21 12 21 3 21 3Z" fill="#B5D96A"/>
            <path d="M3 21L10 14" stroke="#2C4A1E" strokeWidth="2" strokeLinecap="round"/>
          </svg>
          <span>Movement<em>Green</em></span>
        </Link>

        {/* Desktop nav */}
        <nav className={styles.nav}>
          {LINKS.map(({ label, path }) => (
            <Link
              key={path}
              to={path}
              className={`${styles.link} ${pathname === path ? styles.active : ''}`}
            >
              {label}
            </Link>
          ))}
        </nav>

        <div className={styles.right}>
          <Link to="/contact" className={`btn btn-primary btn-sm hide-mobile ${styles.cta}`}>
            Check Eligibility
          </Link>
          <button
            className={styles.burger}
            onClick={() => setMenuOpen(o => !o)}
            aria-label="Toggle menu"
          >
            <span className={menuOpen ? styles.b1open : styles.b1} />
            <span className={menuOpen ? styles.b2open : styles.b2} />
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div className={`${styles.drawer} ${menuOpen ? styles.drawerOpen : ''}`}>
        {LINKS.map(({ label, path }) => (
          <Link
            key={path}
            to={path}
            className={`${styles.dLink} ${pathname === path ? styles.dActive : ''}`}
          >
            {label}
          </Link>
        ))}
        <Link to="/contact" className="btn btn-primary" style={{ marginTop: 8, justifyContent: 'center' }}>
          Check Eligibility
        </Link>
      </div>
    </header>
  );
}
